import ContactInfo from "assets/icons/businessInfo/ContactInfo";
import EconomicInfo from "assets/icons/businessInfo/EconomicInfo";
import IdentifyIcon from "assets/icons/businessInfo/IdentifyIcon";
import businessTypes from "assets/js/businessTypes";
import {SelectInput, TextInput} from "components/Input/FormControl";
import {Cities, States} from "constants/ProvincesList";
import {useFormikContext} from "formik";

export default function useBusinessInfoItems() {
    const data: any = useFormikContext()?.values;
    let cities: any = Cities.filter((x) => x.stateId === 1);
    const state = data && data.state && States.find((x) => x.value === data.state);
    if (state) cities = Cities.filter((x) => x.stateId === state.id);

    return [
        {
            title: "اطلاعات شناسایی",
            Icon: IdentifyIcon,
            input: [
                {
                    Component: TextInput,
                    props: {
                        label: "نام کسب و کار",
                        name: "nickName",
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: TextInput,
                    props: {
                        label: "نام قانونی",
                        name: "legalName",
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: SelectInput,
                    props: {
                        label: "نوع کسب و کار",
                        name: "businessType",
                        selectOption: () => businessTypes,
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: TextInput,
                    props: {
                        label: "زمینه فعالیت",
                        name: "fieldActivity",
                    },
                    col: {
                        xs: 6,
                    },
                },
            ],
        },
        {
            title: "اطلاعات اقتصادی",
            Icon: EconomicInfo,
            input: [
                {
                    Component: TextInput,
                    props: {
                        label: "کد اقتصادی",
                        name: "economicalCode",
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: TextInput,
                    props: {
                        label: "شناسه ملی",
                        name: "nationalID",
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: TextInput,
                    props: {
                        label: "شماره ثبت",
                        name: "registrationNumber",
                    },
                    col: {
                        xs: 6,
                    },
                },
            ],
        },
        {
            title: "اطلاعات تماسی",
            Icon: ContactInfo,
            input: [
                {
                    Component: SelectInput,
                    props: {
                        label: "استان",
                        name: "state",
                        selectOption: () => States,
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: SelectInput,
                    props: {
                        label: "شهر",
                        name: "city",
                        // @ts-ignore
                        selectOption: (stateTitle) => {
                            const state = States.find((s) => s.value === stateTitle);
                            return Cities.filter((c) => c.stateId === state?.id);
                        },
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: TextInput,
                    props: {
                        label: "تلفن",
                        name: "phone",
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: TextInput,
                    props: {
                        label: "کدپستی",
                        name: "postalCode",
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: TextInput,
                    props: {
                        label: "آدرس",
                        name: "address",
                    },
                    col: {
                        xs: 12,
                    },
                },
                {
                    Component: TextInput,
                    props: {
                        label: "ایمیل",
                        name: "email",
                    },
                    col: {
                        xs: 6,
                    },
                },
                {
                    Component: TextInput,
                    props: {
                        label: "وبسایت",
                        name: "webSite",
                    },
                    col: {
                        xs: 6,
                    },
                },
            ],
        },
    ];
}
